/**
 * Format a tonnage number to 2dp.
 *
 * - Does not currently take a language and so will use browser defaults.
 * - If the value is below 0.005, it will return '<0.01'.
 */

export default function formatTonnage(tonnage?: number | null, forceIntEmissions = false): string {
  if (forceIntEmissions) {
    return (tonnage || 0).toLocaleString(undefined, {
      maximumFractionDigits: 0,
    });
  }

  const formatted = (tonnage || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  if (tonnage && parseFloat(formatted) === 0) {
    return '<0.01';
  }
  return formatted;
}
